import { useState } from "react";
import { AgentPromptEditor } from "@/components/agents/AgentPromptEditor";
import { AgentLogViewer } from "@/components/agents/AgentLogViewer";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import { Braces, ListFilter, Settings } from "lucide-react";

const AgentAdminPage = () => {
  const [activeTab, setActiveTab] = useState<string>("prompts");

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Agent Administration</h1>
          <p className="text-muted-foreground mt-1">
            Manage agent prompts, view logs, and test agent behavior
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="grid w-full grid-cols-2 max-w-[400px]">
          <TabsTrigger value="prompts" className="flex items-center gap-2">
            <Settings className="h-4 w-4" />
            Agent Prompts
          </TabsTrigger>
          <TabsTrigger value="logs" className="flex items-center gap-2">
            <ListFilter className="h-4 w-4" />
            Agent Logs
          </TabsTrigger>
        </TabsList>

        <TabsContent value="prompts" className="space-y-6">
          <AgentPromptEditor />
        </TabsContent>

        <TabsContent value="logs" className="space-y-6">
          <AgentLogViewer />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AgentAdminPage;